<template>
  <div v-if="show" class="full-reduction-pop">
    <div class="contentPop">
      <img
        @click="onClose"
        class="closed"
        src="https://iqh-zt-pord-cdn.iqihang.com/xunbao/closed.png"
        alt=""
      />
      <h3>提交成功</h3>
      <img class="success" src="https://iqh-zt-pord-cdn.iqihang.com/xunbao/success.png" alt="" />
      <p>后续可在小程序中修改收货地址、查看物流信息哦</p>
      <div class="checkbtn" @click="myCourse">我知道了</div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';

export default {
  props: {},
  data() {
    return {
      show: false,
    };
  },
  mounted() {},
  methods: {
    // 跳转导学页
    myCourse() {
      wx.miniProgram.navigateBack();
    },
    onClose() {
      this.show = false;
    },
  },
};
</script>
<style scoped lang="scss">
.full-reduction-pop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.3);
  .contentPop {
    position: relative;
    top: 50%;
    width: 634px;
    height: 509px;
    margin: 0 auto;
    padding-top: 50px;
    background: #fff;
    border-radius: 36px;
    transform: translateY(-50%);
    .closed {
      position: absolute;
      top: 36px;
      right: 36px;
      width: 29px;
    }
    .success {
      display: block;
      width: 96px;
      height: 96px;
      margin: 0 auto;
    }
    h3 {
      padding-bottom: 51px;
      color: #333;
      font-weight: 500;
      font-size: 33px;
      line-height: 45px;
      text-align: center;
    }
    p {
      padding: 36px 0 25px 0;
      color: #333;
      font-weight: 400;
      font-size: 25px;
      line-height: 40px;
      text-align: center;
    }
    .checkbtn {
      width: 326px;
      height: 80px;
      margin: 0 auto;
      color: #fff;
      font-weight: 500;
      font-size: 32px;
      line-height: 80px;
      text-align: center;
      background: #ff7f41;
      border-radius: 40px;
    }
  }
}
</style>
